// Mock data for form submissions - will be replaced with backend integration later

export const mockData = {
  contactSubmissions: []
};

export const submitContactForm = (formData) => {
  const submission = {
    id: Date.now(),
    ...formData,
    submittedAt: new Date().toISOString()
  };
  
  mockData.contactSubmissions.push(submission);
  
  // Store in localStorage for persistence across page reloads
  localStorage.setItem('contactSubmissions', JSON.stringify(mockData.contactSubmissions));
  
  return {
    success: true,
    message: 'Thank you! We will contact you shortly.',
    data: submission
  };
};

export const getContactSubmissions = () => {
  const stored = localStorage.getItem('contactSubmissions');
  if (stored) {
    mockData.contactSubmissions = JSON.parse(stored);
  }
  return mockData.contactSubmissions;
};
